export class ApiError extends Error {
  constructor(public code: string, message: string) {
    super(message);
  }
}

const apiOrigin = (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/+$/, "") ?? "";

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${apiOrigin}/api${path}`, {
    ...init,
    cache: "no-store",
    credentials: "include",
    headers: {
      "content-type": "application/json",
      ...init?.headers
    }
  });
  const responseText = await response.text();
  let payload: {
    data?: T;
    code?: string;
    message?: string;
    error?: string | { code: string; message: string };
  } = {};

  if (responseText) {
    try {
      payload = JSON.parse(responseText) as typeof payload;
    } catch {
      throw new ApiError(
        "INVALID_RESPONSE",
        response.ok
          ? "服务器返回了无法识别的响应，请稍后重试"
          : `API 服务暂时不可用（HTTP ${response.status}），请稍后重试`
      );
    }
  }

  if (!response.ok || payload.error) {
    const structuredError = typeof payload.error === "object" ? payload.error : undefined;
    throw new ApiError(
      structuredError?.code ?? payload.code ?? "REQUEST_FAILED",
      structuredError?.message ?? payload.message ?? `请求失败（HTTP ${response.status}）`
    );
  }
  return payload.data as T;
}
